<template>
    <Header />
    <Navi />
    <Search />
    <router-view />
    <Footer />
    <div class="cover" :class="{ 'is-end': is_end }" v-if="!is_hide_cover">
        <div ref="cover"></div>
        <img v-if="bg_image" :src="bg_image" :style="{ opacity: bgImageOpacity }" />
    </div>
    <!-- <Cookies v-if="show_cookies" @close="show_cookies = false" /> -->
</template>
<script>
import lottie from 'lottie-web';
import Header from '@/components/Header.vue';
import Navi from '@/components/Navi.vue';
import Search from '@/components/Search.vue';
import Footer from '@/components/Footer.vue';
// import Cookies from "@/components/Cookies.vue";

export default {
    data() {
        return {
            bg_image: '',
            is_end: false,
            is_hide_cover: false,
            show_cookies: false,
            scrollHistory: new Map(),
            isBackNavigation: false,
        }
    },
    components: {
        Header,
        Navi,
        Search,
        Footer,
        // Cookies,
    },

    watch: {
        '$route'(to, from) {
            // Save current scroll position before route change
            if (from.path) {
                this.scrollHistory.set(from.path, window.pageYOffset || document.documentElement.scrollTop);
            }

            // Handle scroll behavior based on navigation type
            this.$nextTick(() => {
                if (this.isBackNavigation && this.scrollHistory.has(to.path)) {
                    // Restore scroll position for back navigation
                    const savedPosition = this.scrollHistory.get(to.path);
                    window.scrollTo(0, savedPosition);
                } else {
                    // Scroll to top for new navigation
                    window.scrollTo(0, 0);
                }
                // Reset back navigation flag
                this.isBackNavigation = false;
            });
        },

        // '$route' (newRoute, oldRoute) {
        //     if (this.is_init && typeof window.ga === 'function') {
        //         setTimeout(() => {
        //             gtag('event', 'page_view', {
        //                 page_path: location.pathname,
        //             });
        //         }, 1000);
        //     } else {
        //         this.is_init = true;
        //     }
        // },
        '$route.params': {
            handler(params) {
                this.updateClass(params);
            },

            immediate: true,
        },
    },

    mounted() {
        // Initialize dark mode from localStorage
        const savedDarkMode = localStorage.getItem('darkMode');
        if (savedDarkMode === 'true') {
            document.documentElement.classList.add('dark-mode');
        }

        // Listen for browser back/forward button
        this.handlePopState = () => {
            this.isBackNavigation = true;
        };
        window.addEventListener('popstate', this.handlePopState);

        // Save initial scroll position
        this.scrollHistory.set(this.$route.path, 0);
    },

    beforeDestroy() {
        // Clean up event listener
        if (this.handlePopState) {
            window.removeEventListener('popstate', this.handlePopState);
        }
    },

    methods: {
        updateClass(params) {
            // this.$store.state.show_navi = false;
            let body_class = '';
            if (this.$route.name !== 'home') body_class = 'not-home ';
            if (typeof this.$route.name === 'string') body_class = body_class + 'page-' + this.$route.name;
            if (params.slug) body_class = body_class + ' slug-' + params.slug;
            if (params.category) body_class = body_class + ' category-' + params.category;
            // if (!this.show_cookies) document.documentElement.classList.remove('disabled-scroll');

            document.body.className = body_class;
            this.$store.state.show_menus = false;
            this.$store.state.disabled_scroll = false;

            setTimeout(() => {
                document.documentElement.classList.remove('disabled-scroll');
            }, 100);

            // Scroll behavior is now handled by $route watcher
            // The commented out scroll logic has been moved there

            // setTimeout(() => {
            //     let forms = document.querySelectorAll('.wpcf7');
            //     forms.forEach(e => {
            //         if (!e.classList.contains('inited')) {
            //             console.log(e)
            //             let wpcf = new Form(e, window.globals.home_url);
            //             wpcf.init();
            //         }
            //     });
            // }, 1000);

        },

        loadShopify() {
            var script = document.createElement('script');
            script.async = true;
            script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
            // script.onload = ShopifyBuyInit;
        },
    },


    mounted() {
        this.$ajax.get('/get-products').then(res => {
            this.$store.state.products = res.data.products;
        });

        this.$ajax.get('/get-cover').then(res => {
            let random_item = res.data.image[Math.floor(Math.random() * res.data.image.length)];

            this.bg_image = random_item['sizes']['2048x2048'];
            const animationData = JSON.parse(res.data.json);

            const params = {
                container: this.$refs.cover,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: animationData
            };

            // const img = this.$refs.cover.querySelector('img');
            setTimeout(() => {

                const anim = lottie.loadAnimation(params);

                anim.addEventListener('complete', () => {
                    setTimeout(() => {
                        this.is_end = true;

                        setTimeout(() => {
                            this.is_hide_cover = true;
                        }, 550);
                    }, 30);
                });
            }, 100);

        });

        this.loadShopify();
        if (window.localStorage.getItem('hide_popup') === null) this.show_cookies = true;
        this.$store.state.site_name = window.globals.name;
        this.$store.state.site_description = window.globals.description;

        // const params = {
        //     container: this.$refs.cover,
        //     renderer: 'svg',
        //     loop: true,
        //     autoplay: true,
        //     animationData: animationData
        // };


        // const anim = lottie.loadAnimation(params);
    },
}
</script>

<style lang="scss">
@import "@/assets/sass/fonts";
@import "@/assets/sass/reset";

/********* Base */
$padding: 1.5rem;

// remove scroll bar
::-webkit-scrollbar {
    display: none;
}

:root {
    --inner-width: 160rem;
    --content-width: 80rem;
    --base-size: 1.7rem;
    --medium-size: 2rem;
    --artist-size: 2.4rem;
    --large-size: 2.8rem;
    --small-size: 1.4rem;
    --tiny-size: 1.2rem;
    --title-size: 4.2rem;
    --big-size: 6.25rem;
    --letter-spacing: 0rem;
    --breadcrumb: 2.4rem;

    --side-padding: 6.2rem;
    --padding-25: #{$padding / 4};
    --padding-50: #{$padding / 2};
    --padding: #{$padding};
    --padding-x2: #{$padding * 2};
    --padding-x3: #{$padding * 3};
    --padding-x4: #{$padding * 4};
    --padding-x5: #{$padding * 5};
    --padding-x6: #{$padding * 6};
    --padding-x7: #{$padding * 7};
    --padding-x8: #{$padding * 8};
    --padding-x12: #{$padding * 12};

    --padding-50-neg: -#{$padding / 2};
    --padding-neg: -#{$padding};
    --padding-x2-neg: -#{$padding * 2};

    // --padding-x5: #{$padding * 5};
    // --padding-x6: #{$padding * 6};

    --font: 'Reply', 'Helvetica', Arial, sans-serif;
    --font-color: #000000;
    --bg-color: #ffffff;
    --light-gray: #F2F2F2;
    --gray: #d9d9d9;
    --dark-gray: #898989;
    --yellow: #F7E148;
    // --purple: #C06BE8;

    @media only screen and (max-width: 768px) {
        --large-size: 4rem;
    }

}

/* Accesible mode Variables */
html.dark-mode {
    --font-color: #ffffff;
    --bg-color: #403A1B;
    --light-gray: #2a2a2a;
    --gray: #404040;
    --dark-gray: #cccccc;
    --yellow: #BBD8F2;
}

// @media only screen and (max-width: 800px) {
//     $padding: 2rem;
// }

input,
text,
keygen,
select,
button,
meter,
progress,
pre {
    font-family: var(--font);
}

/********* Links */
// :focus {
//     outline: 3px dashed var(--dark-gray);
// }

a,
a:visited,
a:active {
    color: var(--font-color);
    // outline: none;
    text-decoration: none;
    // transition: color .2s;
    -webkit-transition: color 0.2s;
    -moz-transition: color 0.2s;
    -ms-transition: color 0.2s;
    -o-transition: color 0.2s;
    transition: color 0.2s;
}

*[tabindex="0"],
a:focus {
    // outline-width: 3px;
    // outline-style: dashed;
    outline-color: black;
}

a:hover {
    text-decoration: none;
    color: var(--theme-2);
}

// input:-webkit-autofill {
//     box-shadow: 0 0 0px 1000px white inset;
// }

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

strong,
b {
    font-weight: normal;
}

i {
    font-style: normal;
}

em {
    font-style: italic;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
}

::-webkit-input-placeholder {
    color: var(--gray);
}

::-moz-placeholder {
    color: var(--gray);
}

:-ms-input-placeholder {
    color: var(--gray);
}

:-moz-placeholder {
    color: var(--gray);
}

::-moz-selection {
    background: var(--gray);
    text-shadow: none;
    color: white;
}

::selection {
    background: var(--gray);
    text-shadow: none;
    color: white;
}

.mobile-item {
    display: none;
}

.desktop-item {
    display: block;
}

html {
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-size: 10px;
    background-color: var(--bg-color);
    overflow: overlay;

    &.disabled-scroll {
        overflow: hidden !important;
    }

    &.hide-bar {
        overflow: hidden;
    }

    &.theme--spring {
        &:root {
            --theme-1: #486030;
            --theme-2: #F7AC18;
        }
    }

    &.theme--early-summer {
        &:root {
            --theme-1: #6F4A32;
            --theme-2: #92C0FB;
        }
    }

    &.theme--mid-summer {
        &:root {
            --theme-1: #A26E21;
            --theme-2: #AD00FF;
        }
    }

    &.theme--autumn {
        &:root {
            --theme-1: #48372B;
            --theme-2: #F7E148;
        }
    }

    &.theme--winter {
        &:root {
            --theme-1: #595A64;
            --theme-2: #ED3326;
        }
    }

    &.theme--accessible-mode {
        &:root {
            --theme-1: #403A1B;
            --theme-2: #BBD8F2;
        }
    }

    &.dark-mode {
        &:root {
            --theme-1: #403A1B;
            --theme-2: #BBD8F2;
            --font-color: #ffffff;
        }
    }

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        border: 2px solid transparent;
        background-clip: content-box;
        background-color: transparent;
        transition: .2s background-color ease;
    }

    &:hover::-webkit-scrollbar-thumb {
        background-color: rgba(#000, .35);
    }

}

html body {
    font-family: var(--font);
    color: var(--font-color);
    background-color: var(--bg-color);
    // font-feature-settings: 'ss02';

    /* Font smoothing */
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: var(--base-size);
    min-height: 100vh;
    line-height: 1.35;
}


// Syntax for old style tabular numbers 
// p {
//     font-feature-settings: "onum", "tnum";
// }

em {
    font-style: italic;
}

.ui-button {
    padding: .7rem 2rem;
    border: .3rem solid;
    font-weight: bold;
    background: var(--theme-2);
    border-color: var(--theme-2);
    color: var(--font-color);

    &:hover {
        background: var(--font-color);
        border-color: var(--font-color);
        color: white;
    }
}

.ui-plus {
    color: #000;

    svg path {
        stroke: currentColor;
    }
}

/* dark mode */

html.dark-mode {
    .navi-wrap {
        background-color: var(--theme-1);

        .menu-item a,
        .menu-item .box {
            background-color: white;

            i,
            span {
                color: black;
            }
        }

        .menu-item:nth-child(10),
        .menu-item:nth-child(11) {

            i,
            span {
                color: white;
            }
        }
    }

    .shopify-buy__btn,
    .shopify-buy__option-select__select {
        color: var(--theme-1);
    }

    .shopify-buy__select-icon {
        fill: var(--theme-1);
    }

    .search-wrap {
        .logo svg {
            fill: #000;
        }

        .input-box {
            color: black;

            input {
                color: black;
            }
        }

        .close svg{
            fill: #000;
        }
    }

    .ui-plus {
        color: #fff;
    }

    .ui-post-sidebar .links {
        border-top: solid white;
        border-bottom: solid white;
    }

    .ui-custom-item .svg-wrap svg g:first-child path {
        fill: var(--theme-1);
    }

    .ui-item {
        a {
            background-color: rgba(0, 0, 0, 0.5);
        }

        .info-text {
            color: black;
        }

        &:hover h2 {
            color: white !important;
            transition: 0.4s white;
        }

        a:hover {
            text-decoration: none;
            color: var(--font-color);
            background-color: rgba(0, 0, 0, 0.8);
            transition: 0.4s rgba(0, 0, 0, 0.8);
        }
    }

    .sideLinkWrapIn::before {
        border-top: 2px solid white;
    }

    .sideLinkWrapIn::after {
        border-right: 2px solid white;
    }

    .sideLinkWrapIn a::before {
        border-left: 2px solid white;
    }

    .sideLinkWrapIn a::after {
        border-bottom: 2px solid white;
    }



    .ui-hover {
        &:hover {
            color: white;
        }

        .ui-hover--svg svg g path {
            stroke: white;
        }
    }

    .product-content .top {
        background-color: #403A1B;
    }

    .ui-product-item {
        a {
            background-color: rgba(0, 0, 0, 0.3);
        }

        a:hover {
            text-decoration: none;
            color: var(--font-color);
            background-color: rgba(0, 0, 0, 0.3);
        }
    }


    .artists-content .ui-list,
    .shop-content .ui-list {
        background-color: var(--theme-1);
    }

    .ui-gallery-3 .info-text {
        background-color: black;
        border-right: 2rem solid black;
        border-left: 2rem solid black;
    }
}


.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

#app,
.wrap {
    min-height: 100vh;
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 100%;
}

.inner {
    width: auto;
    max-width: var(--inner-width);
    margin-left: auto;
    margin-right: auto;
    padding-left: var(--padding-x2);
    padding-right: var(--padding-x2);
}

.cols {
    display: flex;
    flex-wrap: wrap;
    // align-items: flex-start;
    margin-left: var(--padding-neg);
    margin-right: var(--padding-neg);
}

.col-2-1 {
    width: 50%;
    box-sizing: border-box;
    padding-left: var(--padding);
    padding-right: var(--padding);
    // margin-left: var(--padding-50-neg);
    // margin-right: var(--padding-50-neg);
}

.col-3-2 {
    width: 66.66%;
    box-sizing: border-box;
    padding-left: var(--padding);
    padding-right: var(--padding);
    // margin-left: var(--padding-50-neg);
    // margin-right: var(--padding-50-neg);
}

.col-3-1 {
    width: 33.33%;
    box-sizing: border-box;
    padding-left: var(--padding);
    padding-right: var(--padding);
}

.col-3-3 {
    width: 100%;
    box-sizing: border-box;
    padding-left: var(--padding);
    padding-right: var(--padding);
    // margin-left: var(--padding-50-neg);
    // margin-right: var(--padding-50-neg);
}

.col-4-1 {
    width: 25%;
    box-sizing: border-box;
    padding-left: var(--padding);
    padding-right: var(--padding);
}

.col-5-1 {
    width: 20%;
    box-sizing: border-box;
    padding-left: var(--padding);
    padding-right: var(--padding);
}

.img-wrap {
    position: relative;
    width: 100%;

    &::before {
        display: block;
        content: '';
    }

    img {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    &.img-3x4 {
        &::before {
            padding-bottom: 75%;
        }
    }

    &.img-4x3 {
        &::before {
            padding-bottom: 150%;
        }
    }

    &.img-1x1 {
        &::before {
            padding-bottom: 100%;
        }
    }
}


.cover {
    position: fixed;
    background-color: #000000;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 999999999;
    opacity: 1;
    transition: opacity .5s ease;

    &::before {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        content: '';
        background-color: #000;
        opacity: .2;
        mix-blend-mode: multiply;
        z-index: 2;
    }

    &.is-end {
        opacity: 0;
        display: none;
    }

    svg {
        position: absolute;
        left: 0%;
        top: 0%;
        width: 100% !important;
        height: 100% !important;
        z-index: 3;
        fill: white !important;
    }

    img {
        display: block;
        position: absolute;
        left: 0%;
        top: 0%;
        height: 100%;
        width: 100%;
        object-fit: cover;

        // filter: blur(12.5px);
    }
}


.in-text-footnote {
    color: var(--theme-2);
}

@media only screen and (max-width: 1500px) {
    html {
        font-size: .6668vw;
    }
}

@media only screen and (max-width: 768px) {
    $padding: 1.5rem;

    :root {
        --inner-width: auto;
        --base-size: 2.4rem;
        --medium-size: 3rem;
        --small-size: 1.8rem;
        --tiny-size: 1.8rem;
        --title-size: 4rem;
        --letter-spacing: 0rem;
        // --big-size: 3rem;
        // --large-size: 4rem;

        --side-padding: #{$padding};
        --padding-25: #{$padding / 4};
        --padding-50: #{$padding / 2};
        --padding: #{$padding};
        --padding-x2: #{$padding * 2};
        --padding-x3: #{$padding * 3};
        --padding-x4: #{$padding * 4};

        --padding-50-neg: -#{$padding / 2};
        --padding-neg: -#{$padding};
    }

    html {
        font-size: 1.5vw;
        overflow: scroll;
    }

    .col-3-2 {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }

    .col-3-1 {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }

    .col-4-1 {
        width: 50%;
    }

    .col-5-1 {
        width: 50%;
    }

}
</style>
